function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m 148.67,124.2 c 0,0 0,0 -100.67,100.7 -3.611186,3.84639 -3.516296,9.86502 0.214342,13.59566 3.730638,3.73064 9.749272,3.82553 13.595658,0.21434 l 86.9,-86.91 89.56,89.57 c 3.87927,3.32726 9.66838,3.09849 13.273,-0.52451 C 255.14761,237.2225 255.34694,231.4323 252,227.57 148.67,124.2 148.67,124.2 148.67,124.2 Z",
  id: "path2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m 148.63,40.60001 c 0,0 0,0 -100.669998,100.69999 -3.611186,3.84639 -3.516296,9.86502 0.214342,13.59566 3.730638,3.73064 9.749272,3.82553 13.595658,0.21434 L 148.67,68.2 l 89.56,89.57 c 3.87927,3.32726 9.66838,3.09849 13.273,-0.52451 3.60461,-3.62299 3.80394,-9.41319 0.457,-13.27549 C 148.63,40.60001 148.63,40.60001 148.63,40.60001 Z",
  id: "path2-3"
});

var SvgUpgradePlan = function SvgUpgradePlan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpgradePlan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upgrade-plan.7cc5c9d9.svg";
export { ForwardRef as ReactComponent };